import { render, staticRenderFns } from "./excelViewer.vue?vue&type=template&id=01879a47&scoped=true&"
import script from "./excelViewer.vue?vue&type=script&lang=js&"
export * from "./excelViewer.vue?vue&type=script&lang=js&"
import style0 from "./excelViewer.vue?vue&type=style&index=0&id=01879a47&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01879a47",
  null
  
)

export default component.exports